<template>
  <v-row no-gutters :class="{ 'text--disabled': disabled }" justify="space-between">
    <v-col :class="!fillWidth ? 'draggable-list-col' : ''">
      <v-row no-gutters class="pb-3" align="center" v-if="title || !disableGroupAdding">
        <v-col cols="auto" class="text-left" v-if="title">
          <span class="font-weight-medium">
            {{ title }}
          </span>
        </v-col>
        <template v-if="!disableGroupAdding">
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <base-button :disabled="disabled" @click="$emit('addGroup')" :straight-text="addGroupTitle" class="mr-0" />
          </v-col>
        </template>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <draggable-list-draggable
            :items="value"
            :allow-elements-on-main-level="allowElementsOnMainLevel"
            :allow-one-element-on-main-level="allowOneElementOnMainLevel"
            :allow-nested-groups="allowNestedGroups"
            :disabled="disabled"
            :hideable-groups="hideableGroups"
            :disable-draggable="disableDraggable"
            :disable-borders="disableBorders"
            :elements-dots-items="elementsDotsItems"
            :groups-dots-items="groupsDotsItems"
            :item-title-key="itemTitleKey"
            :child-items-key="childItemsKey"
            v-on="$listeners"
          >
            <template v-for="(value, key) in $scopedSlots" #[key]="scope">
              <slot :name="key" v-bind="scope" />
            </template>
          </draggable-list-draggable>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import DraggableListDraggable from '@/components/DraggableListDraggable';
export default {
  name: 'DraggableList',
  components: { DraggableListDraggable },
  props: {
    addGroupPath: {
      type: String,
      default: 'button.addGroup',
    },
    addGroupStraight: {
      type: String,
      default: '',
    },
    allowElementsOnMainLevel: {
      type: Boolean,
      default: false,
    },
    allowOneElementOnMainLevel: {
      type: Boolean,
      default: false,
    },
    hideableGroups: {
      type: Boolean,
      default: false,
    },
    allowNestedGroups: {
      type: Boolean,
      default: false,
    },
    childItemsKey: {
      type: String,
      default: 'items',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableDraggable: {
      type: Boolean,
      default: false,
    },
    disableBorders: {
      type: Boolean,
      default: false,
    },
    disableGroupAdding: {
      type: Boolean,
      default: false,
    },
    elementsDotsItems: {
      type: Array,
    },
    groupsDotsItems: {
      type: Array,
    },
    itemTitleKey: {
      type: String,
      default: 'name',
    },
    titlePath: {
      type: String,
      default: '',
    },
    titleStraight: {
      type: String,
      default: '',
    },
    fillWidth: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    addGroupTitle() {
      return this.addGroupStraight || this.$i18n.t(this.addGroupPath);
    },
    title() {
      return this.titleStraight || this.$i18n.t(this.titlePath);
    },
  },
};
</script>
<style scoped lang="scss">
.draggable-list-col {
  @include customColSize(48);
}
</style>
